module.exports = __webpack_public_path__ + "img/radio-sandakan.fb7151f6.jpg";